const themeFonts = {
  helvetica: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  ivar: "'Ivar', Georgia, serif",
}

export default themeFonts
